import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, CTABand } from "../components/ui-kit";
import { Reveal } from "../motion";
import { PARTNERS, PARTNERS_CONTACT } from "../content";
import { PHOTOS } from "../assets";

export default function Socios() {
  return (
    <>
      <PageHero
        eyebrow="Sócios-fundadores"
        titleLines={["Duas trajetórias", "complementares."]}
        lead="Lucas Pahl Schaan Núñez e Rodrigo Menezes Burgueño reúnem experiências em tributação, atividade empresarial, contratos e contencioso. Suas trajetórias são distintas e complementares, e convergem em um mesmo método de análise e acompanhamento direto."
      />
      <section className="bg-bone py-20 lg:py-28">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 space-y-8">
          {Object.entries(PARTNERS).map(([slug, p], i) => {
            const c = PARTNERS_CONTACT[p.key];
            return (
              <Reveal key={slug} delay={i * 0.08}>
                <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-8 lg:gap-14 bg-white border border-ink/10 rounded-2xl overflow-hidden">
                  <div className="relative bg-ink min-h-[360px] lg:min-h-full overflow-hidden">
                    <img src={PHOTOS[p.key]} alt={`Retrato profissional de ${p.name}`} className="absolute inset-0 w-full h-full object-cover object-top" />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" />
                    <div className="absolute bottom-0 left-0 p-8">
                      <h2 className="serif text-3xl lg:text-4xl text-bone">{p.name}</h2>
                      <p className="text-gold text-sm mt-2">{p.role}</p>
                      <p className="text-bone/50 text-sm mt-1">{c.phone}</p>
                    </div>
                  </div>
                  <div className="p-9 lg:py-12 lg:pr-12 flex flex-col justify-center">
                    <p className="text-ink/70 text-lg leading-relaxed font-light">{p.lead}</p>
                    <div className="mt-8 flex flex-wrap gap-4">
                      <Link to={`/socios/${slug}`} data-testid={`socio-profile-${p.key}`} className="btn-gold">Conheça {p.name.split(" ")[0]} <ArrowRight size={16} /></Link>
                      <a href={c.wa} target="_blank" rel="noreferrer" data-testid={`socio-wa-${p.key}`} className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-ink/20 text-ink hover:border-gold hover:bg-gold/10 transition-all text-sm">WhatsApp</a>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
      <CTABand title={["Como os sócios", "atuam em conjunto."]} text="Quando uma questão atravessa diferentes áreas, os sócios reúnem perspectivas complementares sem fragmentar sua condução." />
    </>
  );
}
